module.exports = __webpack_public_path__ + "media/images/subject_img/MATERIAL SCIENCE-11eda0027962fd47430d774e0c38be00.jpg";